// If you are adding a term to the ActionSubjectId glossary,
// please add a member of the Data team to your PR

// For help naming UI components, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329336/UI+Events

// For help naming track event entities, see:
// https://hello.atlassian.net/wiki/spaces/MEASURE/pages/134329319/Track+Events

const buttons = {
  addTeamFromCollectionsButton: 'addTeamFromCollectionsButton',
  addToEnterpriseButton: 'addToEnterpriseButton',
  atlassianAccountOnboardingBannerSnoozeButton:
    'atlassianAccountOnboardingBannerSnoozeButton',
  atlassianAccountCompleteOnboardingSuccessButton:
    'atlassianAccountCompleteOnboardingSuccessButton',
  atlassianOnboardingHelpDocButton: 'atlassianOnboardingHelpDocButton',
  atlassianOnboardingMixedUseAccountButton:
    'atlassianOnboardingMixedUseAccountButton',
  atlassianAccountOnboardingForWorkButton:
    'atlassianAccountOnboardingForWorkButton',
  atlassianOnboardingGoToSettingsToRemoveEmailButton:
    'atlassianOnboardingGoToSettingsToRemoveEmailButton',
  atlassianOnboardingLoginWithAtlassianButton:
    'atlassianOnboardingLoginWithAtlassianButton',
  atlassianOnboardingMenuBackButton: 'atlassianOnboardingMenuBackButton',
  atlassianAccountOnboardingNotWorkButton:
    'atlassianAccountOnboardingNotWorkButton',
  atlassianAccountOnboardingOverlayCloseButton:
    'atlassianAccountOnboardingOverlayCloseButton',
  atlassianOnboardingPersonalAccountButton:
    'atlassianOnboardingPersonalAccountButton',
  atlassianOnboardingRemoveEmailButton: 'atlassianOnboardingRemoveEmailButton',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  attachmentGetPowerEnableButton: 'attachmentGetPowerEnableButton',
  avatarGravatarOptionButton: 'avatarGravatarOptionButton',
  avatarNoneOptionButton: 'avatarNoneOptionButton',
  avatarPreviouslyUploadedOptionButton: 'avatarPreviouslyUploadedOptionButton',
  bcFreeTrial: 'bcFreeTrial',
  bcPayment: 'bcPayment',
  bcTeam: 'bcTeam',
  bcUpgradePill: 'bcUpgradePill',
  bcUpgradePrompt: 'bcUpgradePrompt',
  bcUpgradeFromTemplatesStoryHeaderLink:
    'bcUpgradeFromTemplatesStoryHeaderLink',
  bcUpgradeFromTemplatesPowerUpButton: 'bcUpgradeFromTemplatesPowerUpButton',
  boardDirectoryCloseButton: 'boardDirectoryCloseButton',
  boardMenuDrawerCloseButton: 'boardMenuDrawerCloseButton',
  boardsMenuButton: 'boardsMenuButton',
  cancelButton: 'cancelButton',
  cardMapEditLocationButton: 'cardMapEditLocationButton',
  cardMapLocationButton: 'cardMapLocationButton',
  changeEmailButton: 'changeEmailButton',
  convertToTemplateButton: 'convertToTemplateButton',
  copyLinkButton: 'copyLinkButton',
  createCardButton: 'createCardButton',
  createCardFromTemplateButton: 'createCardFromTemplateButton',
  customBoardBackground: 'customBoardBackground',
  customPowerUpLearnMoreHeaderLink: 'customPowerUpLearnMoreHeaderLink',
  dismissButton: 'dismissButton',
  downloadLink: 'downloadLink',
  emptyPowerUpSlotButton: 'emptyPowerUpSlotButton',
  enterpriseButton: 'enterpriseButton',
  exportButton: 'exportButton',
  freeTeam: 'freeTeam',
  fullNameProfileLink: 'fullNameProfileLink',
  goldLink: 'goldLink',
  hideVotesBoardPref: 'hideVotesBoardPref',
  homeTab: 'homeTab',
  integrationsNavigationMenuLink: 'integrationsNavigationMenuLink',
  invitationsPermsDrawerNavigationItem: 'invitationsPermsDrawerNavigationItem',
  inviteTeamMemberLink: 'inviteTeamMemberLink',
  inviteTeamMembersButton: 'inviteTeamMembersButton',
  inviteToBoardDisableLink: 'inviteToBoardDisableLink',
  inviteToBoardLink: 'inviteToBoardLink',
  inviteToBoardLinkCopyButton: 'inviteToBoardLinkCopyButton',
  linkCopyButton: 'linkCopyButton',
  marketingOptInButton: 'marketingOptInButton',
  marketingOptOutButton: 'marketingOptOutButton',
  memberSearchResultLink: 'memberSearchResultLink',
  miniProfileAvatar: 'miniProfileAvatar',
  moonshotExploreLink: 'moonshotExploreLink',
  moonshotStep: 'moonshotStep',
  powerUpAddButton: 'powerUpAddButton',
  powerUpEditButton: 'powerUpEditButton',
  removeEmailButton: 'removeEmailButton',
  setAsPrimaryEmailButton: 'setAsPrimaryEmailButton',
  setUpAtlassianAccountAndRemoveEmailsButton:
    'setUpAtlassianAccountAndRemoveEmailsButton',
  showAllActivityButton: 'showAllActivityButton',
  showAllPowerUpsButton: 'showAllPowerUpsButton',
  showCommentsOnlyButton: 'showCommentsOnlyButton',
  showFewerPowerUpsButton: 'showFewerPowerUpsButton',
  upgradeButton: 'upgradeButton',
  upgradeToBCButton: 'upgradeToBCButton',
  useTemplateButton: 'useTemplateButton',
  viewTemplateButton: 'viewTemplateButton',
} as const;

const links = {
  alwaysKeepMenuOpenLink: 'alwaysKeepMenuOpenLink',
  attachmentGetPowerLearnMoreLink: 'attachmentGetPowerLearnMoreLink',
  backgroundOptionsLink: 'backgroundOptionsLink',
  bcUpgradeFromTemplatesStoryHeaderLink:
    'bcUpgradeFromTemplatesStoryHeaderLink',
  bcUpgradeFromTemplatesPowerUpDescriptionLink:
    'bcUpgradeFromTemplatesPowerUpDescriptionLink',
  boardMenuPowerUpLink: 'boardMenuPowerUpLink',
  boardMenuToggleLink: 'boardMenuToggleLink',
  boardSearchResultLink: 'boardSearchResultLink',
  businessClassLink: 'businessClassLink',
  cardMapExternalLink: 'cardMapExternalLink',
  cardSearchResultLink: 'cardSearchResultLink',
  categoryNavLink: 'categoryNavLink',
  createBoardLink: 'createBoardLink',
  createCollectionLink: 'createCollectionLink',
  createNewOrgLink: 'createNewOrgLink',
  customPowerUpLearnMoreHeaderLink: 'customPowerUpLearnMoreHeaderLink',
  downloadLink: 'downloadLink',
  enterpriseLink: 'enterpriseLink',
  fullNameProfileLink: 'fullNameProfileLink',
  goldLink: 'goldLink',
  inviteToBoardLink: 'inviteToBoardLink',
  integrationsNavigationMenuLink: 'integrationsNavigationMenuLink',
  inviteToBoardDisableLink: 'inviteToBoardDisableLink',
  mapLocationPowerUpLink: 'mapLocationPowerUpLink',
  memberSearchResultLink: 'memberSearchResultLink',
  learnMoreLink: 'learnMoreLink',
  seeClosedBoardsLink: 'seeClosedBoardsLink',
  showLessActiveBoardsLink: 'showLessActiveBoardsLink',
  showMoreCardsLink: 'showMoreCardsLink',
  showSearchTipsLink: 'showSearchTipsLink',
  startWithTemplateLink: 'startWithTemplateLink',
  teamInvitation: 'teamInvitation',
  teamPageLink: 'teamPageLink',
  teamSearchResultLink: 'teamSearchResultLink',
} as const;

const inputFields = {
  linkCopyInput: 'linkCopyInput',
  searchInput: 'searchInput',
} as const;

const pills = {
  bcUpgradePill: 'bcUpgradePill',
} as const;

// For links in the board menu drawer
const drawerNavigationItems = {
  changeOrgDrawerNavigationItem: 'changeOrgDrawerNavigationItem',
  closeBoardDrawerNavigationItem: 'closeBoardDrawerNavigationItem',
  convertToBoardDrawerNavigationItem: 'convertToBoardDrawerNavigationItem',
  commentPermsDrawerNavigationItem: 'commentPermsDrawerNavigationItem',
  cookieConsentDrawerNavigationItem: 'cookieConsentDrawerNavigationItem',
  copyBoardDrawerNavigationItem: 'copyBoardDrawerNavigationItem',
  invitationsPermsDrawerNavigationItem: 'invitationsPermsDrawerNavigationItem',
  leaveDrawerNavigationItem: 'leaveDrawerNavigationItem',
  makeTemplateFromBoardDrawerNavigationItem:
    'makeTemplateFromBoardDrawerNavigationItem',
  powerUpDirectoryDrawerNavigationItem: 'powerUpDirectoryDrawerNavigationItem',
  removeOrgDrawerNavigationItem: 'removeOrgDrawerNavigationItem',
  selfJoinDrawerNavigationItem: 'selfJoinDrawerNavigationItem',
  votingPermsDrawerNavigationItem: 'votingPermsDrawerNavigationItem',
  watchDrawerNavigationItem: 'watchDrawerNavigationItem',
} as const;

// For info boxes, callouts within a component
const overlays = {
  collectionsExplainerOverlay: 'collectionsExplainerOverlay',
} as const;

// For options within a dropdown component
const dropdownItems = {
  inviteTeamToBoardDropdownItem: 'inviteTeamToBoardDropdownItem',
} as const;

// For tracking set, change, etc of board preferences
const boardPrefs = {
  hideVotesBoardPref: 'hideVotesBoardPref',
  votingBoardPref: 'votingBoardPref',
} as const;

const shortcuts = {
  boardsMenuShortcut: 'boardsMenuShortcut',
  escapeShortcut: 'escapeShortcut',
  searchShortcut: 'searchShortcut',
} as const;

const otherActionSubjectIds = {
  atlassianAccountOnboardingOverlay: 'atlassianAccountOnboardingOverlay',
  bcFreeTrialUpsell: 'bcFreeTrialUpsell',
  bcUpgradePrompt: 'bcUpgradePrompt',
  boardInvitation: 'boardInvitation', // Adding members to board
  boardsMenuInlineDialog: 'boardsMenuInlineDialog',
  businessClassUpgrade: 'businessClassUpgrade',
  cardMapLocation: 'cardMapLocation',
  closedBoardsModal: 'closedBoardsModal',
  colorBlindFriendlyMode: 'colorBlindFriendlyMode',
  colorBoardBackground: 'colorBoardBackground',
  commentReaction: 'commentReaction',
  customBoardBackground: 'customBoardBackground',
  emailBoardInvitation: 'emailBoardInvitation', // For new members invited to board
  fullUpgradePrompt: 'fullUpgradePrompt',
  homeTab: 'homeTab', // Tabs are deprecated; use screens in `Source.ts`
  leaveBoardMenu: 'leaveBoardMenu',
  marketingEmail: 'marketingEmail',
  miniProfileAvatar: 'miniProfileAvatar',
  photoBoardBackground: 'photoBoardBackground',
  powerUpCard: 'powerUpCard',
  reactionMenuIcon: 'reactionMenuIcon',
  reactionSelectorInlineDialog: 'reactionSelectorInlineDialog',
  savingSearchQuery: 'savingSearchQuery',
  searchInlineDialog: 'searchInlineDialog',
  searchMember: 'searchMember',
  searchResultCard: 'searchResultCard',
  searchSuggestion: 'searchSuggestion',
  searchTeam: 'searchTeam',
  templatePreview: 'templatePreview',
  templateTile: 'templateTile',
  unknown: 'unknown', // This represents a generic error case and should be used sparingly!
} as const;

export const ActionSubjectId = {
  ...buttons,
  ...links,
  ...inputFields,
  ...pills,
  ...drawerNavigationItems,
  ...overlays,
  ...dropdownItems,
  ...boardPrefs,
  ...otherActionSubjectIds,
  ...shortcuts,
} as const;

export type ActionSubjectIdType = typeof ActionSubjectId[keyof typeof ActionSubjectId];

export const isValidActionSubjectId = (a: ActionSubjectIdType) => {
  const validSources = Object.values(ActionSubjectId);
  return validSources.includes(a);
};
